module.exports = __webpack_public_path__ + "static/logo_new-68ce5ebf348e644149ef7169f1afba70.svg";